<template>
    <div class="image-picker image-list" v-bind:class="{'image-picker--in-modal': picker}">
        <div class="form__row form__row--search-in-list">
            <div class="form__item">
                <form-input length-type="w--xl" v-model="search" name="search" placeholder="Vyhledat"/>
            </div>
        </div>
        <div :key="index" v-for="(image, index) in filteredImages" class="image-picker__item image-item">
            <image-media-item @pick="$emit('pick', $event)" :picker="picker" :image="image"
                              :selected="selected.indexOf(image.id) !== -1"/>
        </div>
    </div>
</template>

<script>
import filter from 'lodash/filter';
import ImageMediaItem from './ImageItem';
import FormInput from '../../../../components/Form/Input/FormInput';
import {clearDiacritics} from '../../../../system/helpers/string.helper';

export default {
    name:       'ImageMediaList',
    components: {FormInput, ImageMediaItem},
    props:      {
        selected: {
            type:     Array,
            required: false,
            default:  () => [],
        },
        picker:   {
            type:     Boolean,
            required: false,
            default:  () => false,
        },
    },
    data() {
        return {
            search:         '',
            filteredImages: [],
        }
    },
    watch:      {
        images: function () {
            this.filter();
        },
        search: function () {
            this.filter();
        }
    },
    computed:   {
        images() {
            return this.$store.getters['media/images'];
        }
    },
    mounted() {
        this.filter();
    },
    methods:    {
        filter() {
            if (this.search.length === 0) {
                this.filteredImages = this.images;
            } else {
                this.filteredImages = filter(this.images, ({title}) => {
                    return clearDiacritics(title).toLowerCase().indexOf(clearDiacritics(this.search).toLowerCase()) > -1;
                });
            }
        }
    }
}
</script>


